import React from 'react';
//help us connect js
import ReactDOM from 'react-dom';

import App from "./App";
import "./index.css";

ReactDOM.render(<App />, document.getElementById('root'));
